import { actionTypes } from "./constants";

export const initialState = {
    data: null,   
    previousRequestSource: null,
    fetching: false,
}

export const conversionChartReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_CONVERSION_CHART_DATA:
            return {
                ...state,
                data: action.payload
            }
        case actionTypes.SET_CONVERSION_CHART_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_CONVERSION_CHART_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 